import { Box, Stack, useTheme } from '@mui/material';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import Button from '@/components/Button';
import Image from 'next/image';
import useOnScreen from '@/hooks/useOnScreen';
import { useEffect, useRef } from 'react';

let threshold = 0.8;

const MarketsSection = () => {
  const { matches } = useResponsive();
  const ImageContainerRef = useRef<HTMLDivElement | null>(null);
  const isOnScreen = useOnScreen(ImageContainerRef, { threshold });

  return (
    <Stack position="relative" gap={{ xs: 9, lg: 18 }} mb={{ xs: 1, lg: 50.5 }}>
      <Stack gap={{ xs: 1, lg: 2 }}>
        <Typography
          textAlign="center"
          variant={matches({ xs: 'body1', lg: 'h6' })}
          component="h2"
          weight="bold"
        >
          بازار معاملاتی ارزهای دیجیتال رابکس
        </Typography>
        <Typography
          textAlign="center"
          variant={matches({ xs: 'body3', lg: 'body2' })}
          mb={{ xs: 2, lg: 6 }}
        >
          در پنل معامله حرفه ای (همتا به همتا) رابکس می‌توانید با قیمت دلخواه
          خودتان مستقیم با کاربران دیگر معامله کنید.
        </Typography>
        <a
          href="https://p.rabex.ir/fa/trade/USDTTMN"
          target="_blank"
          style={{ alignSelf: 'center' }}
        >
          <Button
            sx={{
              zIndex: 2,
              alignSelf: 'center',
              width: matches({ xs: 240, lg: 274 })
            }}
            size={matches({ xs: 'small', lg: 'medium' })}
            color="primary"
          >
            می‌خواهم معامله کنم
          </Button>
        </a>
      </Stack>
      <Stack position="relative">
        {matches({
          lg: (
            <Stack
              ref={ImageContainerRef}
              position="relative"
              alignItems="center"
            >
              <Box
                sx={{
                  width: 594,
                  height: 594,
                  zIndex: 1,
                  opacity: 0.1,
                  borderRadius: 148.5,
                  left: -236.12,
                  bottom: 30.09,
                  position: 'absolute',
                  background: '#16C784',
                  filter: 'blur(67.5px)'
                }}
              />
              <Box
                sx={{
                  width: 594,
                  height: 594,
                  zIndex: 1,
                  opacity: 0.1,
                  borderRadius: 148.5,
                  right: -319.25,
                  bottom: 30.09,
                  position: 'absolute',
                  background: '#3861FB',
                  filter: 'blur(53.621px)'
                }}
              />
              <Box
                sx={{
                  width: 650,
                  height: 650,
                  zIndex: 1,
                  opacity: 0.1,
                  borderRadius: 162.5,
                  top: -162,
                  position: 'absolute',
                  background: '#EA3943',
                  filter: 'blur(96.217px)'
                }}
              />
              <Box zIndex={2}>
                <Image
                  width={1085}
                  height={790}
                  src="/assets/market-lg.png"
                  alt="markets-lg"
                />
              </Box>
              <Box
                sx={{
                  zIndex: 1,
                  position: 'absolute',
                  top: -128,
                  left: -244,
                  filter: 'blur(8.911892890930176px)',
                  opacity: 0.5
                }}
              >
                <Image
                  width={606}
                  height={195}
                  src="/assets/Chart.png"
                  alt="candle-r"
                />
              </Box>
              <Box
                sx={{
                  zIndex: 1,
                  position: 'absolute',
                  top: 0,
                  right: -255,
                  filter: 'blur(8.911892890930176px)',
                  opacity: 0.5,
                  transform: 'scaleX(-1)'
                }}
              >
                <Image
                  width={606}
                  height={195}
                  src="/assets/Chart.png"
                  alt="candle-r"
                />
              </Box>
              <Box
                sx={{
                  zIndex: 3,
                  position: 'absolute',
                  bottom: -95.66,
                  left: isOnScreen ? -74.77 : -274,
                  opacity: isOnScreen ? 1 : 0,
                  transition: isOnScreen ? 'all 1s 0s' : 'all 1s 2s'
                }}
              >
                <Image
                  width={333}
                  height={570}
                  src="/assets/Convertor.png"
                  alt="convertor"
                />
              </Box>
              <Box
                sx={{
                  zIndex: 3,
                  position: 'absolute',
                  bottom: -97.95,
                  right: isOnScreen ? -116.25 : -286,
                  opacity: isOnScreen ? 1 : 0,
                  transition: isOnScreen ? 'all 1s 0s' : 'all 1s 2s'
                }}
              >
                <Image
                  width={339}
                  height={579}
                  src="/assets/landing.png"
                  alt="convertor"
                />
              </Box>
            </Stack>
          ),
          xs: (
            <Stack position="relative">
              <Box
                sx={{
                  width: 323,
                  height: 323,
                  zIndex: 1,
                  opacity: 0.1,
                  borderRadius: 162.5,
                  top: -57,
                  left: -108,
                  position: 'absolute',
                  background: '#16C784',
                  filter: 'blur(61.05px)'
                }}
              />
              <Box
                sx={{
                  width: 323,
                  height: 323,
                  zIndex: 1,
                  opacity: 0.1,
                  borderRadius: 162.5,
                  top: -57,
                  right: -108,
                  position: 'absolute',
                  background: '#EA3943',
                  filter: 'blur(61.05px)'
                }}
              />
              <Box zIndex={2} sx={{ textAlign: 'center' }}>
                <Image
                  width={375}
                  height={413}
                  src="/assets/market-xs.png"
                  alt="markets-xs"
                />
              </Box>
            </Stack>
          )
        })}
      </Stack>
    </Stack>
  );
};

export default MarketsSection;
